import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-lg-bold text-racq-dark-grey" }
const _hoisted_2 = { class: "mb-6 text-base text-racq-med-grey" }

import { convertSitecoreFormFieldToVueFormField } from '@/composables/useFormInputData';
import { IPolicyHolderDetails, ISitecoreFormGenericInput } from '@/interfaces';
import { computed, ref, watch } from 'vue';
import SectionPanel from '../SectionPanel/SectionPanel.vue';
import RACQFormKit from '../RACQFormKit/RACQFormKit.vue';
import AddressLookupOptions from '../AddressLookupOptions/AddressLookupOptions.vue';
import { isPOBoxAddress } from '@/utils/regex-helpers';
import { joinAddressComponentsForPolicyholder } from '@/mappers';
import { toBool } from '@/utils/convert';
import { replaceBookmark } from '@/utils/bookmark.replace';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { cloneDeep } from 'lodash-es';


export default /*@__PURE__*/_defineComponent({
  __name: 'IQAccountCreation',
  props: {
    fields: {},
    policyholder: {},
    index: {},
    title: {}
  },
  setup(__props: any) {

const props = __props;

const showAddressLookupRef = ref<InstanceType<typeof RACQFormKit>>();
const addressEl = ref<InstanceType<typeof AddressLookupOptions>>();
const addressStore = computed(() => addressEl.value?.getStore());
const policyholderAddress = computed(() => {
  return joinAddressComponentsForPolicyholder(props.policyholder, true, false);
});
const badResidentialAddress = computed(() => {
  return isPOBoxAddress(policyholderAddress.value!);
});

const subTitle = computed(() => {
  const subTitle = cloneDeep(props.fields.find((f) => f.name == 'subTitle'));
  if (badResidentialAddress.value && subTitle?.label.value) {
    subTitle.label.value = subTitle.label.value.replace('the correct', `${props.policyholder.firstname?.value}'s'`);
  }
  return subTitle;
});

const confirmResidentialAddress = computed(() => {
  const bindings = convertSitecoreFormFieldToVueFormField(
    props.fields.find((field: ISitecoreFormGenericInput) => field.name == 'confirmResidentialAddress')!,
    'confirmResidentialAddress'
  );

  bindings.preContent = replaceBookmark('firstName', bindings.preContent!, props.policyholder.firstname?.value);
  bindings.preContent = replaceBookmark('address', bindings.preContent!, policyholderAddress.value!);
  return bindings;
});

const addressLookup = computed(() => {
  return props.fields?.find((field: ISitecoreFormGenericInput) => field.name == 'addressLookup');
});

const showAddressComponent = computed(() => {
  return (
    (showAddressLookupRef.value?.model && !toBool(showAddressLookupRef.value?.model)) || badResidentialAddress.value
  );
});

watch(addressStore, async (newVal, oldVal) => {
  if (newVal && !oldVal) {
    addressStore.value?.setupAddressComponent({
      isPostalAddress: false,
      allowOverseasAddress: true,
      showPostalSameAsInsuredAddressSelection: false,
      allowPhysicalAddressesOnly: true,
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(SectionPanel, null, {
    sectionPanelContent: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.policyholder.firstname?.value) + " " + _toDisplayString(_ctx.policyholder.surname?.value), 1),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
      (!badResidentialAddress.value)
        ? (_openBlock(), _createBlock(RACQFormKit, {
            key: policyholderAddress.value,
            ref_key: "showAddressLookupRef",
            ref: showAddressLookupRef,
            bindings: confirmResidentialAddress.value
          }, null, 8, ["bindings"]))
        : _createCommentVNode("", true),
      _createVNode(_component_FormKit, {
        type: "hidden",
        value: _ctx.policyholder.policyHolderId,
        name: "policyHolderId"
      }, null, 8, ["value"]),
      (showAddressComponent.value)
        ? (_openBlock(), _createBlock(_unref(RichText), {
            key: subTitle.value?.label.value,
            class: "text-racq-med-grey text-base mb-4",
            field: subTitle.value?.label
          }, null, 8, ["field"]))
        : _createCommentVNode("", true),
      (showAddressComponent.value)
        ? (_openBlock(), _createBlock(AddressLookupOptions, _mergeProps({
            key: 2,
            ref_key: "addressEl",
            ref: addressEl,
            instanceIdentifier: _ctx.policyholder.policyHolderId
          }, addressLookup.value, { defaultIsOverseasOption: false }), null, 16, ["instanceIdentifier"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})